import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { RecoilRoot } from 'recoil';
import Injector from './App/Injector';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from '@components';
import ReactQueryProvider from '@utils/ReactQueryProvider';
import { isPreloadError, registerPreloadErrorHandler } from '@utils';

const options = {
	init: {
		distributed_tracing: { enabled: true },
		logging: { enabled: false, autoStart: false },
		privacy: { cookies_enabled: true },
		ajax: { deny_list: ['bam.nr-data.net'] }
	},
	info: {
		beacon: 'bam.nr-data.net',
		errorBeacon: 'bam.nr-data.net',
		licenseKey: import.meta.env.VITE_NEW_RELIC_LICENSE_KEY,
		applicationID: import.meta.env.VITE_NEW_RELIC_APPLICATION_ID,
		sa: 1
	},
	loader_config: {
		accountID: import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID,
		trustKey: import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID,
		agentID: import.meta.env.VITE_NEW_RELIC_APPLICATION_ID,
		licenseKey: import.meta.env.VITE_NEW_RELIC_LICENSE_KEY,
		applicationID: import.meta.env.VITE_NEW_RELIC_APPLICATION_ID
	}
}

const newRelicAgent = new BrowserAgent(options);

registerPreloadErrorHandler(newRelicAgent);

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

const handleError = (error: Error) => {
	// Stale-build chunk failures after a deploy are tracked via the vitePreloadError page action, not as errors (AP2-1821)
	if (isPreloadError(error)) return;
	newRelicAgent.noticeError(error);
}
root.render(
	<React.StrictMode>
		<RecoilRoot>
			<ReactQueryProvider>
				<ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
					<Injector />
				</ErrorBoundary>
			</ReactQueryProvider>
		</RecoilRoot>
	</React.StrictMode>
);
